import React from 'react';

import './SideNav.css';

const SideNav = props => {
  return <header className="side-nav">{props.children}</header>;
};

export default SideNav;
